/* Auto-generated by scripts/emit-build-info.js */
export const BUILD_INFO = {
  "version": "1.19.0",
  "buildTime": "2026-10-26T14:55:32.889Z"
} as const;
export type BuildInfo = typeof BUILD_INFO;
